import { BasketProductBox } from './basketProductBox'

export default BasketProductBox
